"use client";

import { Dialog, DialogContent } from "@punchup/ui-common/shadcn/ui/dialog";
import { Drawer, DrawerContent } from "@punchup/ui-common/shadcn/ui/drawer";
import { VenueEvents, trackEvent } from "@punchup/analytics";
import { useEffect, useState } from "react";

import { FOLLOW_LOCATIONS } from "@punchup/data/legacy";
import { SignInSignUpForm } from "@punchup/ui-common/components/signin";
import { VenueCheckoutHeader } from "@punchup/ui-common/components/checkout";
import { VenuePagesRow, getVenuePage } from "../../data/venue_pages";
import { createClientComponentClient } from "@punchup/data/supabase/client";
import { useMediaQuery } from "@punchup/utils/hooks";

export default function CheckoutModalOrDrawerVenue({
  isOpen,
  setIsOpen,
  venueToFollow,
  redirectTo,
  userEmail,
  followLocation = FOLLOW_LOCATIONS.VENUE_PAGE,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  venueToFollow: VenuePagesRow;
  redirectTo: string;
  userEmail?: string;
  followLocation?: FOLLOW_LOCATIONS;
}) {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [venue, setVenue] = useState<VenuePagesRow | null>(null);

  useEffect(() => {
    const supabase = createClientComponentClient();
    getVenuePage(supabase, { id: venueToFollow.id }).then((venue) => {
      setVenue(venue);
    });
  }, [venueToFollow.id]);

  const commonContent = (
    <div className="flex flex-col items-center px-4 md:px-0">
      <VenueCheckoutHeader venue={venueToFollow} />
      <div className="pt-4 pb-12 md:pt-2 md:pb-10">
        <SignInSignUpForm
          redirectTo={redirectTo}
          buttonText="Join the Guest List"
          venueToFollow={venueToFollow}
          userEmail={userEmail}
          followLocation={followLocation}
        />
      </div>
    </div>
  );

  useEffect(() => {
    if (isOpen) {
      trackEvent(VenueEvents.OPENED_VENUE_CHECKOUT_MODAL, {
        venuePageId: venue?.id,
        venueName: venueToFollow.name,
        isDesktop: isDesktop,
      });
    }
  }, [isOpen, venueToFollow, isDesktop, venue]);

  if (!isDesktop) {
    return (
      <Drawer open={isOpen} onOpenChange={setIsOpen}>
        <DrawerContent className="z-[99] font-regular flex items-center gap-x-4">
          {commonContent}
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="rounded-lg md:w-full gap-y-0 md:max-w-md">
        {commonContent}
      </DialogContent>
    </Dialog>
  );
}
